export default "__VITE_ASSET__Dw3ZRn30__"